// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host div {
  background-color: #FFFFFF;
}
:host #beername {
  font-size: 1.1em;
  font-weight: bold;
}
:host #breweryname {
  font-size: 1em;
}
:host #brewerylocation {
  font-size: 1em;
}
:host img {
  height: 80px;
  width: 80px;
}
:host .beerstats {
  font-size: 1.2em;
  font-weight: bold;
  text-align: right;
}
:host .statslabel {
  font-size: 0.9em;
  text-align: center;
  text-align: left;
  margin-left: -6px;
}
:host .smaller {
  font-weight: normal;
  font-size: 1em;
}
:host img {
  width: auto;
  height: auto;
  max-width: 100px;
  max-height: 75px;
  margin: auto;
  display: block;
}
:host .imgholder {
  text-align: center;
  max-height: 90px;
  margin: auto;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
